import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Icon from '@material-ui/icons/Lock';
const useStyles = makeStyles({
  icon: {
    position: 'absolute',
    marginLeft: 10,
    marginTop: 10,
    width: 48,
    height: 48,
  },
  spinner: {

  }
});

export default function Loader() {
  const classes = useStyles();
  return (
    <div>
      <Icon className={classes.icon}/>
      <CircularProgress size={68} className={classes.spinner} color="inherit"/>
    </div>
  );
}
